import { render, staticRenderFns } from "./BackgroundRenderer.vue?vue&type=template&id=7ccda714&scoped=true"
import script from "./BackgroundRenderer.vue?vue&type=script&lang=js"
export * from "./BackgroundRenderer.vue?vue&type=script&lang=js"
import style0 from "./BackgroundRenderer.vue?vue&type=style&index=0&id=7ccda714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccda714",
  null
  
)

export default component.exports